import {react} from 'react';
import MyTable from '../components/myTable';
import '../css/style.css';
import {useSelector} from 'react-redux';


const Users = () => {
    const marginLeft = useSelector(state => state.style.payload.marginLeft)

    return (
        <div className='main'> 
            {/* <h2> Users </h2> */}
            <MyTable page={"Users List"}/>
        </div>
    )
}

export default Users